module.exports = __webpack_public_path__ + "static/media/vanA.d9f3c5a7.png";